import { get } from 'lodash';
import { parsePrice } from '../../../../../../lib/helper';
import Serving from './classes/Serving';
import Amount from './classes/Amount';

export const getPizzaServingsList = (partialServingPricing) => {
    return [ 
        createWholeServing(), 
        createLeftServing(partialServingPricing), 
        createRightServing(partialServingPricing)
    ];
}
export const createWholeServing = () => {
    return new Serving(Serving.WHOLE, 'Whole Pizza', 1);
}
export const createLeftServing = (partialServingPricing) => {
    return new Serving(Serving.LEFT, 'Left Side', partialServingPricing);
}
export const createRightServing = (partialServingPricing) => {
    return new Serving(Serving.RIGHT, 'Right Side', partialServingPricing);
}

export const getPizzaAmountsList = (cost) => {
    return [
        createNormalAmount(cost),
        createLightAmount(cost),
        createExtraAmount(cost)
    ];
}
export const createNormalAmount = (cost) => {
    return new Amount(Amount.NORMAL, 'Regular', cost);
}
export const createLightAmount = (cost) => {
    return new Amount(Amount.LIGHT, 'Light', cost);
}
export const createExtraAmount = (cost) => {
    return new Amount(Amount.EXTRA, 'Extra', cost*2);
}

export const calculatePizzaModifierBuilderCost = (modifierCost, selectedAmount, selectedServing) => {
    const selectedAmountCost = selectedAmount.cost ? selectedAmount.cost : modifierCost;
    const selectedServingCost = selectedServing.cost ? selectedServing.cost : 1;
    return selectedAmountCost*selectedServingCost;
};

export const initializePizzaCreatorModifiers = (menuItem) => {
    let forcedModifier;
    let listType;
    let pizzaMods = get(menuItem, 'pizza_creator.pizza_mods', []);
    pizzaMods.forEach(pizzaMod => {
        for (let i = 0; i < pizzaMod.forced_modifiers.length; i++) {
            forcedModifier = pizzaMod.forced_modifiers[i];
            listType = pizzaMod.forced_modifier_list_type;

            //----------------------------------
            //  Set Modifier selection
            //----------------------------------
            forcedModifier.selected = false;
            if(listType === 'choice' && i===0){
                //  In lists with choice type, first modifier is always selected by default
                forcedModifier.selected = true;
                //  New price has to be calculated base on the selection
                menuItem.price = parseFloat(parsePrice(forcedModifier.cost, true)) + parseFloat(parsePrice(menuItem.price, true));
            }

            //----------------------------------
            //  Set Modifier display type
            //----------------------------------
            forcedModifier.use_builder = false;
            if(listType === 'checklist'){
                //  In lists with checklist type, modifiers will use the Modifier Builder
                forcedModifier.use_builder = true;
                //  Set initial selections for Modifier Builder content
                forcedModifier.selected_amount = createNormalAmount(forcedModifier.cost);
                forcedModifier.selected_serving = createWholeServing();
            }
        }
    });
  };

  export const getSelectedPizzaCreatorModifiers = (pizzaMods) => {
    let selected = [];
    pizzaMods.forEach(pizzaMod => {
      let selectedModifiers = pizzaMod.forced_modifiers.filter(modifier => modifier.selected === true);
      selected = selected.concat(selectedModifiers);
    });
    return selected;
  };


// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/utils.js